import { monitorQrcodesConstants } from '../constants';
import {List} from "immutable";

export function monitorQrcodes(state = {}, action) {
  switch (action.type) {
    case monitorQrcodesConstants.GETMONITOR_QRCODES_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        data: new List()
      });
    case monitorQrcodesConstants.GETMONITOR_QRCODES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data
      });
    case monitorQrcodesConstants.GETMONITOR_QRCODES_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state
  }
}
